"use strict";

exports.__esModule = true;
exports.StyledCardHeader = exports.StyledCardFooter = exports.StyledCardBody = exports.StyledCard = void 0;

var _styled = require("@manifest-ui/styled");

const themeKey = 'card';
const StyledCard = (0, _styled.styled)('div', {
  themeKey
})({
  backgroundColor: '#FFFFFF',
  borderRadius: 'medium',
  boxShadow: 'small',
  boxSizing: 'border-box',
  overflow: 'hidden'
});
exports.StyledCard = StyledCard;
const StyledCardBody = (0, _styled.styled)('div', {
  slot: 'body',
  themeKey
})({
  p: 4
});
exports.StyledCardBody = StyledCardBody;
const StyledCardFooter = (0, _styled.styled)('div', {
  slot: 'footer',
  themeKey
})({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-end',
  p: 4
});
exports.StyledCardFooter = StyledCardFooter;
const StyledCardHeader = (0, _styled.styled)('div', {
  slot: 'header',
  themeKey
})({
  fontFamily: 'body',
  fontSize: 'large',
  fontWeight: 'bold',
  letterSpacing: 'tight',
  lineHeight: 'large',
  p: 4
});
exports.StyledCardHeader = StyledCardHeader;